// store/page/material/materialThunk.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  FETCH_UF_DIMENSIONAL_OBS,
  ADD_UF_DIMENSIONAL_OBS,
  FETCH_UF_VISUAL_OBS,
  FETCH_UF_COMPONENT_NAMES,
  ADD_UF_COMPONENT_NAMES,
  FETCH_UF_MACHINE_NAMES,
  ADD_UF_CROSS_MEMBER_OBS,
  // FETCH_UF_OPERATIONS,
  ADD_UF_MACHINE_NAMES,
  FETCH_OPERATION_NAMES,
  ADD_OPERATION_NAME,
  FETCH_UF_FRAME_TYPES,
  ADD_UF_FRAME_TYPE,
  FETCH_DRG_NUMBERS,
  ADD_DRG_NUMBER,
  FETCH_INSTRUMENTS,
  ADD_INSTRUMENTS,
  ADD_MASTER_OPERATION_NAME,
  FETCH_MASTER_OPERATION_NAMES,
  FETCH_ROOF_DIMENSIONAL_OBS,
  ADD_ROOF_DIMENSIONAL_OBS,
  DELETE_ROOF_DIMENSIONAL_OBS,
  GET_ROOF_DIMENSIONAL_OBS_BY_ID,
  UPDATE_ROOF_DIMENSIONAL_OBS,
  FETCH_TRAIN_TYPES,
  FETCH_UF_CROSS_MEMBER,
  UPDATE_DIMENSIONAL_OBS,
  FETCH_SHIFT_TYPES,
  ADD_TRAIN_TYPE,
  DELETE_TRAIN_TYPE,
  DELETE_DRG_NUMBERE,
  DELETE_UF_FRAME_TYPE,
  DELETE_OPERATION_NAME,
  DELETE_MASTER_OPERATION_NAME,
  DELETE_INTRUMENT_NAME,
  DELETE_COMPONENT_NAME,
  DELETE_CENTRALINE_NAME,
  FETCH_UF_MAKES,
  FETCH_MASTER_DRGNOS,
  STORE_VISUAL_OBS_DATA,
  FETCH_METAL_UF_NUMBER,
  FETCH_DRAWING_NUMBERS,
  FETCH_MASTER_DRGNOS_ALL_BIND,
  FETCH_ROOF_DRG_NUMBERS,
  GET_ALL_NUMBER_BY_MODULE,
  DAILY_TURNOUT_STORE,
  GET_DAILY_TURNOUT,
  ADD_BUFFER_CBC_OBS,
  UPDATE_BUFFER_CBC_OBS,
  FETCH_BUFFER_CBC_OBS,
  GET_BUFFER_CBC_OBS_BY_ID,
  ADD_CR_POSITION,
  LIST_CR_POSITION,
  STORE_DAILY_DISPATCH_REPORT_LIST,
  STORE_DAILY_DISPATCH_REPORT,
  LIST_BACKLOG,
  ADD_BACKLOG,
  GET_BOGIE_STAGE_NUMBERS,
  GET_LIST_DEFECT_MANAGEMENT,
  GET_BOGIE_STATIC_LOAD_DEFECT_REPORT,
  STORE_CR_POSITION,
  CR_POSITION_DETAILS_LIST,
  SHOP_LIST,
  SHOP_FORM_DATA_LIST,
  VERSION_LIST,
  GET_VISUAL_OBS_HISTORY,
  GET_DISTINCT_SHELL_NOS,
  NOTIFICATION_GET,
  NOTIFICATION_GET_SINGLE,
} from '../../../api/apiConstant';
import api from '../../../api/apiServises';

export const fetchUfDimensionallyObsParams = createAsyncThunk(
  'material/fetchUfDimensionallyObsParams',
  async (filterParams, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_UF_DIMENSIONAL_OBS, { params: filterParams });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);

export const fetchUfVisualObsParams = createAsyncThunk(
  'material/fetchUfVisualObsParams',
  async (
    {
      page = 1,
      per_page: perPage = 10,
      search = '',
      metal_type: metalType = '',
      stage_type: stageType = '',
      visual_type: visualType = '',
      frame_type: frameType = '',
    } = {},
    { rejectWithValue },
  ) => {
    try {
      const response = await api.get(FETCH_UF_VISUAL_OBS, {
        params: {
          page,
          per_page: perPage,
          search,
          metal_type: metalType,
          stage_type: stageType,
          visual_type: visualType,
          frame_type: frameType,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          error.message ||
          'Failed to fetch underframe stage -1 visual params',
      );
    }
  },
);

export const fetchUfComponentNames = createAsyncThunk(
  'material/fetchUfComponentNames',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_UF_COMPONENT_NAMES);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch underframe component names',
      );
    }
  },
);

export const fetchUfMachineNames = createAsyncThunk(
  'material/fetchUfMachineNames',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_UF_MACHINE_NAMES);
      console.log(70, response);
      return response?.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch underframe machine names',
      );
    }
  },
);

// Add new material thunk
export const addUfDimesionParams = createAsyncThunk(
  'material/addUfDimesionParams',
  async (materialData, { rejectWithValue }) => {
    try {
      const payload = {
        collection_name: 'uf_dimensional_obs_params',
        ...materialData,
      };
      const response = await api.post(ADD_UF_DIMENSIONAL_OBS, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to add dimensions',
      );
    }
  },
);

// Add new component name thunk
export const addUfComponentNames = createAsyncThunk(
  'material/addUfComponentNames',
  async ({ formData, id }, { rejectWithValue, dispatch }) => {
    try {
      const url = id ? `${ADD_UF_COMPONENT_NAMES}/${id}` : ADD_UF_COMPONENT_NAMES;
      const response = await api.post(url, formData);

      // After successful addition, fetch the updated list
      if (response.status === 200 || response.status === 201) {
        await dispatch(fetchUfComponentNames());
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to add component name',
      );
    }
  },
);

export const addCrossCenterObsParams = createAsyncThunk(
  'material/addCrossCenterObsParams',
  async ({ formData, id }, { rejectWithValue }) => {
    try {
      const url = id ? `${ADD_UF_CROSS_MEMBER_OBS}/${id}` : ADD_UF_CROSS_MEMBER_OBS;
      const response = await api.post(url, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to add component name',
      );
    }
  },
);

// export const fetchUfOperations = createAsyncThunk(
//   'material/fetchUfOperations',
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await api.get(FETCH_UF_OPERATIONS);
//       console.log(22, response);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(
//         error.response?.data || error.message || 'Failed to fetch underframe machine names',
//       );
//     }
//   },
// );

export const addUfMachineNames = createAsyncThunk(
  'material/addUfMachineNames',
  async ({ formData, id }, { rejectWithValue }) => {
    try {
      const url = id ? `${ADD_UF_MACHINE_NAMES}/${id}` : ADD_UF_MACHINE_NAMES;
      const response = await api.post(url, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to add machine name',
      );
    }
  },
);

export const fetchOperationNames = createAsyncThunk(
  'material/fetchOperationNames',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_OPERATION_NAMES);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch operation names',
      );
    }
  },
);

export const addOperationName = createAsyncThunk(
  'material/addOperationName',
  async ({ formData, id }, { rejectWithValue }) => {
    try {
      const url = id ? `${ADD_OPERATION_NAME}/${id}` : ADD_OPERATION_NAME;
      const response = await api.post(url, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to add operation names');
    }
  },
);

export const fetchUfFrameTypes = createAsyncThunk(
  'material/fetchUfFrameTypes',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_UF_FRAME_TYPES);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch frame types',
      );
    }
  },
);

export const addUfFrameType = createAsyncThunk(
  'material/addUfFrameType',
  async ({ formData, id }, { rejectWithValue, dispatch }) => {
    try {
      const url = id ? `${ADD_UF_FRAME_TYPE}/${id}` : ADD_UF_FRAME_TYPE;
      console.log('FormData', formData);
      const response = await api.post(url, formData);

      if (response.status === 200 || response.status === 201) {
        await dispatch(fetchUfFrameTypes());
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to add frame type',
      );
    }
  },
);

export const fetchDrgNumbers = createAsyncThunk(
  'material/fetchDrgNumbers',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_DRG_NUMBERS);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch Drg numbers',
      );
    }
  },
);

// Add Drg Number
export const addDrgNumber = createAsyncThunk(
  'material/addDrgNumber',
  async ({ formData, id }, { rejectWithValue, dispatch }) => {
    try {
      const url = id ? `${ADD_DRG_NUMBER}/${id}` : ADD_DRG_NUMBER;
      const response = await api.post(url, formData);

      // After successful addition, fetch the updated list
      if (response.status === 200 || response.status === 201) {
        await dispatch(fetchDrgNumbers());
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to add Drg number',
      );
    }
  },
);

export const fetchRoofDrgNumbers = createAsyncThunk(
  'material/fetchRoofDrgNumbers',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_ROOF_DRG_NUMBERS);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch Roof Drg numbers',
      );
    }
  },
);

export const fetchInstruments = createAsyncThunk(
  'material/fetchInstruments',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_INSTRUMENTS);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch instruments',
      );
    }
  },
);

export const addInstrumentNames = createAsyncThunk(
  'material/addInstrumentNames',
  async ({ formData, id }, { rejectWithValue }) => {
    try {
      const url = id ? `${ADD_INSTRUMENTS}/${id}` : ADD_INSTRUMENTS;
      const response = await api.post(url, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to add instrument name',
      );
    }
  },
);

export const masterOperationName = createAsyncThunk(
  'material/masterOperationName',
  async ({ formData, id }, { rejectWithValue }) => {
    try {
      const url = id ? `${ADD_MASTER_OPERATION_NAME}/${id}` : ADD_MASTER_OPERATION_NAME;
      const response = await api.post(url, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to add operation name');
    }
  },
);

export const getmasterOperationName = createAsyncThunk(
  'material/fetchMasterOperationNames',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_MASTER_OPERATION_NAMES);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch operation names',
      );
    }
  },
);

// ROOF DIMENSIONAL OBSERVATIONS THUNKS

// export const fetchRoofDimensionalObsParams = createAsyncThunk(
//   'material/fetchRoofDimensionalObsParams',
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await api.get(FETCH_ROOF_DIMENSIONAL_OBS);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(
//         error.response?.data?.message ||
//           error.response?.data ||
//           error.message ||
//           'Failed to fetch roof observations',
//       );
//     }
//   },
// );

export const fetchRoofDimensionalObsParams = createAsyncThunk(
  'material/fetchRoofDimensionalObsParams',
  async (filters = {}, { rejectWithValue }) => {
    // Accept filters object
    try {
      const response = await api.get(FETCH_ROOF_DIMENSIONAL_OBS, { params: filters });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to fetch roof observations',
      );
    }
  },
);

export const addRoofDimensionalObsParams = createAsyncThunk(
  'material/addRoofDimensionalObsParams',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_ROOF_DIMENSIONAL_OBS, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to add roof observation',
      );
    }
  },
);

export const deleteRoofDimensionalObsParams = createAsyncThunk(
  'material/deleteRoofDimensionalObsParams',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.post(`${DELETE_ROOF_DIMENSIONAL_OBS}/${id}`);

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to delete roof observation',
      );
    }
  },
);

export const getRoofDimensionalObsParamsById = createAsyncThunk(
  'material/getRoofDimensionalObsParamsById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`${GET_ROOF_DIMENSIONAL_OBS_BY_ID}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to fetch roof observation details',
      );
    }
  },
);

export const updateRoofDimensionalObsParams = createAsyncThunk(
  'material/updateRoofDimensionalObsParams',
  async ({ data }, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_ROOF_DIMENSIONAL_OBS, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to update roof observation',
      );
    }
  },
);

export const fetchUfTrainTypes = createAsyncThunk(
  'material/fetchUfTrainTypes',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_TRAIN_TYPES);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch train types',
      );
    }
  },
);

export const fetchUfCrossMemberParams = createAsyncThunk(
  'material/fetchUfCrossMemberParams',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_UF_CROSS_MEMBER);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch cross member params',
      );
    }
  },
);
//Uf Dimensional Obs
export const getUfDimensionObsById = createAsyncThunk(
  'material/getUfDimensionObsById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`/api/uf-dimensional-obs/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to fetch observation details',
      );
    }
  },
);

export const updateUfDimensionObs = createAsyncThunk(
  'material/updateUfDimensionObs',
  async ({ data }, { rejectWithValue }) => {
    try {
      // const response = await api.put(`${UPDATE_DIMENSIONAL_OBS}/${id}`, data);
      const response = await api.post(UPDATE_DIMENSIONAL_OBS, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to update observation',
      );
    }
  },
);

export const deleteUfDimensionObs = createAsyncThunk(
  'material/deleteUfDimensionObs',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.delete(`/api/uf-dimensional-obs/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to delete observation',
      );
    }
  },
);

//visual obs

// UPDATE UF VISUAL OBS
export const updateUfVisualObs = createAsyncThunk(
  'material/updateUfVisualObs',
  async ({ data }, { rejectWithValue }) => {
    try {
      const response = await api.post(STORE_VISUAL_OBS_DATA, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to update visual observation',
      );
    }
  },
);

// DELETE UF VISUAL OBS
export const deleteUfVisualObs = createAsyncThunk(
  'material/deleteUfVisualObs',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.delete(`/api/uf-visual-delete/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to delete visual observation',
      );
    }
  },
);

export const fetchShiftTypes = createAsyncThunk(
  'material/fetchShiftTypes',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_SHIFT_TYPES);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch shift types',
      );
    }
  },
);
export const deleteDrgNumber = createAsyncThunk(
  'material/deleteDrgNumber',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.delete(`${DELETE_DRG_NUMBERE}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to delete DRG number',
      );
    }
  },
);

export const deleteUfFrameType = createAsyncThunk(
  'material/deleteUfTrainTypeType',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.delete(`${DELETE_UF_FRAME_TYPE}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to delete train type',
      );
    }
  },
);

export const deleteOperationName = createAsyncThunk(
  'material/deleteOperationName',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.delete(`${DELETE_OPERATION_NAME}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to delete operation name',
      );
    }
  },
);

export const deleteMasterOperationName = createAsyncThunk(
  'material/deleteMasterOperationName',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.delete(`${DELETE_MASTER_OPERATION_NAME}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to delete operation name',
      );
    }
  },
);

export const deleteMachineName = createAsyncThunk(
  'material/deleteMachineName',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.delete(`/api/machine-name/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to delete machine name',
      );
    }
  },
);

export const deleteInstrument = createAsyncThunk(
  'material/deleteInstrument',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.delete(`${DELETE_INTRUMENT_NAME}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to delete instrument',
      );
    }
  },
);
export const deleteComponentName = createAsyncThunk(
  'material/deleteComponentName',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.delete(`${DELETE_COMPONENT_NAME}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to delete component name',
      );
    }
  },
);
export const deleteTrainType = createAsyncThunk(
  'material/deleteTrainType',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.delete(`${DELETE_TRAIN_TYPE}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to delete train type',
      );
    }
  },
);
export const addTrainType = createAsyncThunk(
  'material/addTrainType',
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const url = id ? `${ADD_TRAIN_TYPE}/${id}` : ADD_TRAIN_TYPE;

      const response = await api.post(url, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to add train type',
      );
    }
  },
);

export const deleteUfCrossMember = createAsyncThunk(
  'material/deleteUfCrossMember',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.delete(`${DELETE_CENTRALINE_NAME}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to delete cross member',
      );
    }
  },
);
export const fetchAllMakes = createAsyncThunk(
  'material/fetchAllMakes',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_UF_MAKES);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch shift types',
      );
    }
  },
);
export const fetchAllMasterDrgNos = createAsyncThunk(
  'material/fetchAllMasterDrgNos',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_MASTER_DRGNOS);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch master drg nos',
      );
    }
  },
);

export const fetchFrameNumber = createAsyncThunk(
  'material/fetchFrameNumbers',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_DRG_NUMBERS);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch Drg numbers',
      );
    }
  },
);

export const fetchUfFrameNumber = createAsyncThunk(
  'material/fetchFrameNumbers',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_METAL_UF_NUMBER);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch Drg numbers',
      );
    }
  },
);

export const fetchDrawingNumbers = createAsyncThunk(
  'material/fetchDrawingNumbers',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_DRAWING_NUMBERS);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch Drg numbers',
      );
    }
  },
);

export const AllbingingDrgNos = createAsyncThunk(
  'material/bindDrgNumber',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_MASTER_DRGNOS_ALL_BIND);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch master drg nos',
      );
    }
  },
);

export const fetchAllMasterNumbers = createAsyncThunk(
  'masterNumber/fetchAll',
  async (module, { rejectWithValue }) => {
    try {
      const res = await api.get(GET_ALL_NUMBER_BY_MODULE, { params: { ...module } });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data);
    }
  },
);

export const fetchShellNumbersForFinal = createAsyncThunk(
  'shellNumber/fetchAllFinal',
  async (params, { rejectWithValue }) => {
    try {
      const res = await api.get(GET_ALL_NUMBER_BY_MODULE, { params });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data);
    }
  },
);

// export const storeDailyOutTurnReport = createAsyncThunk(
//   'dailyOutTurn/store',
//   async (data, { rejectWithValue }) => {
//     try {
//       const response = await api.post(DAILY_TURNOUT_STORE, data);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(
//         error.response?.data?.message || error.message || 'Failed to save report',
//       );
//     }
//   },
// );
export const storeDailyOutTurnReport = createAsyncThunk(
  'dailyOutTurn/store',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(DAILY_TURNOUT_STORE, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || {
          message: error.message || 'Failed to save report',
        },
      );
    }
  },
);

export const fetchDailyOutTurnList = createAsyncThunk(
  'dailyOutTurn/fetchList',
  async (filters = {}, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_DAILY_TURNOUT, { params: filters });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to fetch report list',
      );
    }
  },
);
export const addBufferCbcObsParams = createAsyncThunk(
  'material/addBufferCbcObsParams',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_BUFFER_CBC_OBS, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to add roof observation',
      );
    }
  },
);
export const updateBufferCbcObsParams = createAsyncThunk(
  'material/updateBufferCbcObsParams',
  async ({ data }, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_BUFFER_CBC_OBS, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to update roof observation',
      );
    }
  },
);
export const fetchBufferCbcObsParams = createAsyncThunk(
  'material/fetchBufferCbcObsParams',
  async (filters = {}, { rejectWithValue }) => {
    // Accept filters object
    try {
      const response = await api.get(FETCH_BUFFER_CBC_OBS, { params: filters });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to fetch roof observations',
      );
    }
  },
);
export const getBufferCbcParamsById = createAsyncThunk(
  'material/getBufferCbcParamsById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`${GET_BUFFER_CBC_OBS_BY_ID}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to fetch buffer cbc param details',
      );
    }
  },
);

export const storeCrPosition = createAsyncThunk(
  'material/storeCrPosition',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_CR_POSITION, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to store report',
      );
    }
  },
);

export const listCrPosition = createAsyncThunk(
  'material/listCrPosition',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(LIST_CR_POSITION, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to get list report',
      );
    }
  },
);

export const DailyDispatchList = createAsyncThunk(
  'material/DailyDispatchList',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(STORE_DAILY_DISPATCH_REPORT_LIST, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to get list report',
      );
    }
  },
);

export const StoreDailyDispatchReport = createAsyncThunk(
  'material/StoreDailyDispatchReport',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(STORE_DAILY_DISPATCH_REPORT, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to get list report',
      );
    }
  },
);

export const storeBacklog = createAsyncThunk(
  'material/storeBacklog',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_BACKLOG, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to store report',
      );
    }
  },
);

export const listBacklog = createAsyncThunk(
  'material/listBacklog',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(LIST_BACKLOG, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to get list report',
      );
    }
  },
);

export const getStageNumbers = createAsyncThunk(
  'material/getStageNumbers',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_BOGIE_STAGE_NUMBERS, {
        params,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch stage numbers',
      );
    }
  },
);

export const getListDefectManagement = createAsyncThunk(
  'material/getListDefectManagement',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_LIST_DEFECT_MANAGEMENT, {
        params,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch list');
    }
  },
);

export const getStaticLoadDefectTest = createAsyncThunk(
  'material/getStaticLoadDefectTest',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_BOGIE_STATIC_LOAD_DEFECT_REPORT, {
        params,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch defect test',
      );
    }
  },
);

export const storeCrPositionDetails = createAsyncThunk(
  'material/storeCrPositionDetails',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(STORE_CR_POSITION, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to store report',
      );
    }
  },
);

export const listCrPositionDetails = createAsyncThunk(
  'material/listCrPositionDetails',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.get(CR_POSITION_DETAILS_LIST, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to get details report',
      );
    }
  },
);

export const getShopsList = createAsyncThunk(
  'material/getShopsList',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.get(SHOP_LIST, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to get details report',
      );
    }
  },
);
export const getFormStageList = createAsyncThunk(
  'material/getFormStageList',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.get(SHOP_FORM_DATA_LIST, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to get details report',
      );
    }
  },
);
export const fetchVersion = createAsyncThunk(
  'material/fetchVersion',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(VERSION_LIST);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to get version list',
      );
    }
  },
);

export const getfitmentVisualObsHistory = createAsyncThunk(
  'material/getfitmentVisualObsHistory',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`${GET_VISUAL_OBS_HISTORY}${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          'Failed to get visual obs fitment history',
      );
    }
  },
);

export const fetchShellNumbersForFilter = createAsyncThunk(
  'fetchShellNumbersForFilter',
  async (params, { rejectWithValue }) => {
    try {
      const res = await api.get(GET_DISTINCT_SHELL_NOS, { params });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data);
    }
  },
);

export const fetchNotifications = createAsyncThunk(
  'fetchNotifications',
  async (params, { rejectWithValue }) => {
    try {
      const res = await api.get(NOTIFICATION_GET, params);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data);
    }
  },
);

export const fetchSingleNotification = createAsyncThunk(
  'notifications/fetchSingle',
  async (id, { rejectWithValue }) => {
    try {
      const res = await api.get(`${NOTIFICATION_GET_SINGLE}/${id}`);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data);
    }
  },
);
